import { assign } from 'lodash';
import * as api from 'api/api-instance';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  error: null,
  notFound: null,
  meta: {},
  data: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = assign({}, initState);

const getters = {
  InstanceSubscribedPlanSummarized: state => state,
};

const actions = {
  GetInstanceSubscribedPlanSummarized({ commit }) {
    commit(types.INSTANCE_SUBSCRIBED_PLAN_SUMMARIZED_START);
    api.getSubscribedPlanSummarized(
      (response) => {
        commit(types.INSTANCE_SUBSCRIBED_PLAN_SUMMARIZED_SUCCESSFUL, { response });
      },
      (description, status, error) => {
        commit(types.INSTANCE_SUBSCRIBED_PLAN_SUMMARIZED_ERROR, { error });
      },
    );
  },
  ClearInstanceSubscribedPlanSummarized({ commit }) {
    commit(types.CLEAR_INSTANCE_SUBSCRIBED_PLAN_SUMMARIZED_STORE);
  },
};

const mutations = {
  [types.INSTANCE_SUBSCRIBED_PLAN_SUMMARIZED_START](state) {
    assign(state, neutralState, { fetching: true });
  },
  [types.INSTANCE_SUBSCRIBED_PLAN_SUMMARIZED_ERROR](state, { error }) {
    assign(state, neutralState, { error });
  },
  [types.INSTANCE_SUBSCRIBED_PLAN_SUMMARIZED_SUCCESSFUL](state, { response }) {
    assign(state, neutralState, { data: response.data, meta: response.meta });
  },
  [types.CLEAR_INSTANCE_SUBSCRIBED_PLAN_SUMMARIZED_STORE](state) {
    assign(state, {}, initState);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/instance/entities/instance-subscribed-plan-summarized.js